module.exports = __webpack_public_path__ + "static/media/Radio_2.fb90e396.svg";